import {useMediaQuery} from '@mui/material'
import {useDispatch} from 'react-redux'
import {setFilter, useAllSearchFilters} from 'entities/searchPeople'
import {Tabs} from 'entities/searchPeople/ui/tabs'
import {SPAgeFromTo, SPContinents, SPFindMe} from 'features/searchPeople'
import {FilterButton} from 'widgets/searchPeople'
import styles from './styles.module.scss'
import 'shared/ui/styles/popup.scss'

export const SearchPeople = () => {
  const isShowButtonFilter = useMediaQuery('(min-width: 850px)')

  const dispatch = useDispatch()
  const {tab} = useAllSearchFilters()

  return (
    <div className={styles.wrapper}>
      <Tabs
        value={tab}
        onChange={(_, newValue) =>
          dispatch(setFilter({value: newValue, key: 'tab'}))
        }
      />

      <div className={styles.filters}>
        {isShowButtonFilter ? <Filters /> : null}
        {!isShowButtonFilter && <FilterButton />}
      </div>
    </div>
  )
}

const Filters: React.FC = () => {
  return (
    <div className={styles.filterLeft}>
      <label className={styles.label}>Find me:</label>
      <SPFindMe width='100px' className='mr-20' />

      <label className={styles.label}>Age:</label>
      <SPAgeFromTo width='86px' className='mr-20' />

      <label className={styles.label}>Continents:</label>
      <SPContinents width='176px' />
    </div>
  )
}
